import React from 'react'
import PropTypes from 'prop-types'
import { getRange } from 'Utils/mapUtils'
import SvgIcon from 'Components/SvgIcon'
import { BlurCont } from 'Layout'
import cn from 'comma-number'

import { _ListInfo, _SqftRange } from './styles'


const ArchiveListingInfo = (
  {
    beds,
    baths,
    parkings,
    sqft,
    forMobile,
    sqftMax,
    sqftMin,
    isPrint,
    isHiddenOnPrint,
    className,
    listingIsLocked,
  }) => {
  let sqftRange = ''
  if(!sqft) {
    sqftRange = getRange(sqftMin, sqftMax, false)
  }
  return (
    <_ListInfo
      forMobile={forMobile}
      isPrint={isPrint}
      isHiddenOnPrint={isHiddenOnPrint}
      className={className}
    >
      <li>
        <SvgIcon name="#icon-beds" width={15} height={9} />
        <BlurCont blur={listingIsLocked}>{beds || 0}&nbsp;</BlurCont>
        {beds === 'Studio' ? '' : 'beds'}
      </li>
      <li>
        <SvgIcon name="#icon-bath" width={12} height={12} />
        <BlurCont blur={listingIsLocked}>{baths || 0}&nbsp;</BlurCont>bath
      </li>
      <li>
        <SvgIcon name="#icon-parking" width={10} height={9} />
        {parkings ? <><BlurCont blur={listingIsLocked}>{parkings}&nbsp;</BlurCont>parking</> :
          // eslint-disable-next-line
          <><BlurCont blur={listingIsLocked}>No&nbsp;</BlurCont>parking</>}
      </li>
      {sqftRange && sqftRange !== '-' ? (
        <_SqftRange>
          <SvgIcon name="#icon-size" width={9} height={9} />
          <BlurCont blur={listingIsLocked}>{sqftRange}&nbsp;</BlurCont> sqft
        </_SqftRange>
      ) : sqft ? (
        <li>
          <SvgIcon name="#icon-size" width={9} height={9} />
          <BlurCont blur={listingIsLocked}>{cn(sqft)}&nbsp;</BlurCont> sqft
        </li>
      ) : (
        ''
      )}
    </_ListInfo>
  )
}

ArchiveListingInfo.propTypes = {
  beds: PropTypes.string,
  baths: PropTypes.number,
  parkings: PropTypes.number,
  sqft: PropTypes.number,
  sqftMax: PropTypes.number,
  sqftMin: PropTypes.number,
  forMobile: PropTypes.bool,
  isPrint: PropTypes.bool,
  isHiddenOnPrint: PropTypes.bool,
  className: PropTypes.string,
  listingIsLocked: PropTypes.bool,
}
export default ArchiveListingInfo
